import * as React from 'react';

export const PreConference = () => (
  <div className="center bg-light-gray">
    <div className="cf w-100">
      <p className="tc pv2 fw5 f2 bg_orange white">Pre conference</p>
    </div>
    <div className="cf ph2-ns">
      <div className="mw8-ns w-100 center measure pa2">
        <p className="b f4 tc">Venue: A BLOCK AUDITORIUM</p>
        <p className="b f4 tc mb4">Bangabandhu Sheikh Mujib Medical University (BSMMU)</p>
        <p className="f3 b tc mb3">Master demostration on cadaver</p>
        <p className="f4 b mb4">Date: 19th January, 2018</p>
        <div className="w-100 cf">
          <div className="fl w-100 w-50-ns">
            <p className="f3 b">Surgical technique</p>
          </div>
          <div className="fl w-100 w-50-ns">
            <p className="f4 tr-ns">Time 8.00am - 1.30pm</p>
          </div>
        </div>
        <div className="w-100">
          <ul className="f5 mb4">
            <li>Anterior craniofacial resection</li>
            <li>Compartmental resection of infatemporal Fossa</li>
            <li>Facial translocation approach</li>
            <li>Compartmental tongue resection</li>
            <li>Total glossectomy <br/> Orbital extenteration</li>
          </ul>
        </div>
        <div className="cf w-100">
          <div className="fl w-100 w-50-ns">
            <p className="f3 b">Faculty: Prof. Nirav Trivedi</p>
          </div>
        </div>
        <div className="cf w-100">
            <p className="f4 tc mt3 mb4 fw6">Lunch Break: 1.30pm - 2.00pm</p>
          </div>
        <div className="cf w-100">
          <div className="fl w-100 w-50-ns">
            <p className="f3 b">Craniofacial surgery</p>
          </div>
          <div className="fl w-100 w-50-ns">
            <p className="f4 tr-ns">Time 2.00pm - 8.00pm</p>
          </div>
        </div>
        <ul className="f5">
          <li>Orbital box Osteotomy</li>
          <li>Facial Bipatition</li>
          <li>TMJ replacement</li>
          <li>Fronto orbital advancement</li>
          <li>Lefort - 1,2,3 osteotomy</li>
          <li>Distraction Osteogenesis</li>
        </ul>
        <div className="cf w-100">
          <div className="fl w-100 w-50-ns">
            <p className="f3 b mb4">Faculty: Prof. Pramad Suvash</p>
          </div>
        </div>
        <p className="b f5">SEATS ARE LIMITED.</p>
        <p className="b f5">***Registration Fee:</p>
        <p className="b f5">1. For All Doctors - 6000 BDT</p>
        <p className="b f5">2. For Foreign Delegates- 100 US$</p>
      </div>
    </div>
  </div>
);


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/pages/PreConference.tsx